import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LineIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share';
const Share = ({ slug }) => {
  const URL = `${process.env.NEXT_PUBLIC_APP_BASE_URL}${slug}`;
  return (
    <div className="z-[9999] my-6 flex gap-4 lg:flex-col">
      <FacebookShareButton
        className="rounded-full border border-red bg-white px-10 py-2 text-red"
        url={URL}
      >
        <FacebookIcon size={38} round={true} />
      </FacebookShareButton>
      <TwitterShareButton
        className="rounded-full border border-red bg-white px-10 py-2 text-red"
        url={URL}
      >
        <TwitterIcon size={38} round={true} />
      </TwitterShareButton>
      <LinkedinShareButton
        className="rounded-full border border-red bg-white px-10 py-2 text-red"
        url={URL}
      >
        <LinkedinIcon size={38} round={true} />
      </LinkedinShareButton>
      <WhatsappShareButton
        className="rounded-full border border-red bg-white px-10 py-2 text-red"
        url={URL}
      >
        <WhatsappIcon size={38} round={true} />
      </WhatsappShareButton>
      {/* <WhatsappShareButton
                    className='px-10 py-2 border rounded-full border-red text-red bg-white'
                    url={`/events`}
                  >
                    <LineIcon size={38} round={true} />
                  </WhatsappShareButton> */}
    </div>
  );
};

export default Share;
